"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Konami(callback) {
    var konami = {
        addEvent: function (obj, type, fn, ref_obj) {
            if (obj.addEventListener)
                obj.addEventListener(type, fn, false);
            else if (obj.attachEvent) {
                obj["e" + type + fn] = fn;
                obj[type + fn] = function () {
                    obj["e" + type + fn](window.event, ref_obj);
                };
                obj.attachEvent("on" + type, obj[type + fn]);
            }
        },
        input: "",
        pattern: "38384040373937396665",
        load: function (link) {
            this.addEvent(document, "keydown", function (e, ref_obj) {
                if (ref_obj)
                    konami = ref_obj;
                konami.input += e ? e.keyCode : event.keyCode;
                if (konami.input.length > konami.pattern.length)
                    konami.input = konami.input.substr((konami.input.length - konami.pattern.length));
                if (konami.input == konami.pattern) {
                    konami.code(link);
                    konami.input = "";
                    e.preventDefault();
                    return false;
                }
            }, this);
            this.iphone.load(link);
        },
        code: function (link) {
            window.location.href = link;
        },
        iphone: {
            start_x: 0,
            start_y: 0,
            stop_x: 0,
            stop_y: 0,
            tap: false,
            capture: false,
            orig_keys: "",
            keys: ["UP", "UP", "DOWN", "DOWN", "LEFT", "RIGHT", "LEFT", "RIGHT", "TAP", "TAP"],
            input: [],
            code: function (link) {
                konami.code(link);
            },
            load: function (link) {
                this.orig_keys = this.keys;
                konami.addEvent(document, "touchmove", function (e) {
                    if (e.touches.length == 1 && konami.iphone.capture == true) {
                        var touch = e.touches[0];
                        konami.iphone.stop_x = touch.pageX;
                        konami.iphone.stop_y = touch.pageY;
                        konami.iphone.tap = false;
                        konami.iphone.capture = false;
                    }
                });
                konami.addEvent(document, "touchend", function (evt) {
                    konami.iphone.input.push(konami.iphone.check_direction());
                    if (konami.iphone.input.length > konami.iphone.keys.length)
                        konami.iphone.input.shift();
                    if (konami.iphone.input.length === konami.iphone.keys.length) {
                        var match = true;
                        for (var i = 0; i < konami.iphone.keys.length; i++) {
                            if (konami.iphone.input[i] !== konami.iphone.keys[i]) {
                                match = false;
                            }
                        }
                        if (match) {
                            konami.iphone.code(link);
                        }
                    }
                }, false);
                konami.addEvent(document, "touchstart", function (evt) {
                    konami.iphone.start_x = evt.changedTouches[0].pageX;
                    konami.iphone.start_y = evt.changedTouches[0].pageY;
                    konami.iphone.tap = true;
                    konami.iphone.capture = true;
                });
            },
            check_direction: function () {
                var x_magnitude = Math.abs(this.start_x - this.stop_x);
                var y_magnitude = Math.abs(this.start_y - this.stop_y);
                var x = ((this.start_x - this.stop_x) < 0) ? "RIGHT" : "LEFT";
                var y = ((this.start_y - this.stop_y) < 0) ? "DOWN" : "UP";
                var result = (x_magnitude > y_magnitude) ? x : y;
                result = (this.tap == true) ? "TAP" : result;
                return result;
            }
        }
    };
    typeof callback === "string" && konami.load(callback);
    if (typeof callback === "function") {
        konami.code = callback;
        konami.load();
    }
    return konami;
}
exports.default = Konami;
